import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import { useEffect } from "react";
import "./admin.css";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/enquiries", label: "Enquiries" },
  { to: "/admin/content", label: "Content" },
  { to: "/admin/integrations", label: "Integrations" },
  { to: "/admin/evidence", label: "Evidence" },
  { to: "/admin/help", label: "Help" },
  { to: "/admin/settings", label: "Settings" },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAdminAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/admin/login", { replace: true });
      return;
    }
    if (user.must_change_password && pathname !== "/admin/change-password") {
      navigate("/admin/change-password", { replace: true });
    }
  }, [user, loading, pathname, navigate]);

  if (loading) return <div className="ga-loading" data-testid="admin-loading">Checking session…</div>;
  if (!user) return null;

  const isChangePw = pathname === "/admin/change-password";

  return (
    <div className="ga-shell" data-testid="admin-shell">
      <header className="ga-topbar">
        <Link to="/admin" className="ga-topbar__brand" data-testid="admin-brand">
          <span className="ga-topbar__mark">GP</span>
          <span className="ga-topbar__word">Gold Petroleum · Admin</span>
        </Link>
        {!isChangePw && !user.must_change_password && (
          <nav className="ga-topbar__nav" data-testid="admin-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => `ga-topbar__link ${isActive ? "ga-topbar__link--active" : ""}`}
                data-testid={`admin-nav-${slug(n.label)}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        )}
        <div className="ga-topbar__meta">
          <span className="ga-topbar__user" data-testid="admin-user-email">Signed in as {user.email}</span>
          <button className="ga-topbar__logout" onClick={logout} data-testid="admin-logout">
            Sign out
          </button>
        </div>
      </header>
      <main className="ga-main">
        <Outlet />
      </main>
    </div>
  );
}

function slug(s) {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
